var menuButton = document.querySelector("#hamburgerMenu");
if (menuButton) {
    menuButton.addEventListener("click", function (e) {
        if (e.target.classList.contains("active")) {
            document.body.classList.remove("menu_active");
            e.target.classList.remove("active");
            e.target.setAttribute("aria-expanded", "false");
            e.target.setAttribute("aria-label", "Close navigation menu");
        } else {
            document.body.classList.add("menu_active");
            e.target.classList.add("active");
            e.target.setAttribute("aria-expanded", "true");
            e.target.setAttribute("aria-label", "Open navigation menu");
        }
    })
}